import { axios, fileAxios } from '../../plugins/axios'

export default {
  namespaced: true,

  state: {
    documentos: [],
    selectedDocumento: null,
    documentosCargados: false,
    idPersonalCargado: null,
  },

  getters: {
    getDocumentos: (state) => {
      return state.documentos
    },
    getSelectedDocumento: (state) => {
      return state.selectedDocumento
    },
    documentosVigentes: (state) => state.documentos.filter((d) => [1, 2, 3].includes(d.fk_idEstatus)),
    documentosArchivados: (state) => state.documentos.filter((d) => d.fk_idEstatus === 4),
    documentosCargados: (state) => state.documentosCargados,
    idPersonalCargado: (state) => state.idPersonalCargado,
  },

  mutations: {
    SET_DOCUMENTOS(state, documentos) {
      state.documentos = documentos
      state.documentosCargados = true
    },
    SET_SELECTED_DOCUMENTO(state, documento) {
      state.selectedDocumento = { ...documento }
    },
    SET_ID_PERSONAL_CARGADO(state, idPersonal) {
      state.idPersonalCargado = idPersonal
    },
    RESET_DOCUMENTOS_CARGADOS(state) {
      state.documentosCargados = false
      state.idPersonalCargado = null
    },
  },

  actions: {
    fetchDocumentoByPersonal: async function ({ commit }, idPersonal) {
      await axios
        .get('/EonCloud/EstadoFuerza/personal/' + idPersonal + '/documento')
        .then((response) => {
          commit('SET_DOCUMENTOS', response.data.data)
          commit('SET_ID_PERSONAL_CARGADO', idPersonal)
        })
        .catch((error) => console.log(error))
    },

    saveDocumentoPersonal: async function (context, documentoPersonal) {
      await axios
        .post('/EonCloud/EstadoFuerza/personal/' + documentoPersonal.fk_idPersonal + '/documento', documentoPersonal)
        .then(async (response) => {
          let formData = new FormData()
          formData.append('file', documentoPersonal.file)
          formData.append('iddocumentosPersonal', response.data.data[0].ID)
          await fileAxios.post('/Documento/uploadFiles', formData)
          context.commit('SET_SNACKBAR_MESSAGE', 'Documento guardado correctamente.', { root: true })
        })
        .catch(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'No fue posible guardar el documento.', { root: true })
        })
    },

    updateDocumentoPersonal: async function (context, documentoPersonal) {
      await axios
        .put(
          '/EonCloud/EstadoFuerza/personal/' + documentoPersonal.fk_idPersonal + '/documento/' + documentoPersonal.id,
          documentoPersonal
        )
        .then(async (response) => {
          const formData = new FormData()
          formData.append('file', documentoPersonal.file)
          formData.append('iddocumentosPersonal', documentoPersonal.id)
          await fileAxios.post('/Documento/uploadFiles', formData)
          context.commit('SET_SNACKBAR_MESSAGE', 'Documento guardado correctamente.', { root: true })
        })
        .catch(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'No fue posible editar el documento.', { root: true })
        })
    },

    updateEstatusDocumentoPersonal: async function ({ commit }, documentoPersonal) {
      await axios
        .put(
          '/PoliciaCuadrantes/EstadoFuerza/personal/' +
            documentoPersonal.fk_idPersonal +
            '/documento/' +
            documentoPersonal.iddocumentosPersonal +
            '/estatus',
          {
            fk_idEstatus: documentoPersonal.fk_idEstatus,
          }
        )
        .then((response) => {
          // //console.log('OK')
        })
        .catch((error) => console.log(error))
    },
  },
}
